<template>
  <a-layout-content>
    <a-form layout="inline">
      <a-form-item label="上传周期">
        <a-select style="width: 290px" v-model="defaultTermsetdata">
          <a-select-option v-for="item in termsetdata" :key="item.ID">
            {{ item.Tname }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="获取日期">
        <a-range-picker :default-value="[moment().startOf('week'), moment().endOf('week')]" :format="dateFormat"
          :ranges="dataRange" @change="onChangeDate" />
      </a-form-item>
      <a-form-item>
        <a-button @click="Getvaildbet">
          <a-icon type="upload" /> 同步获取
        </a-button>
      </a-form-item>
      <a-form-item>
        <a-checkbox-group style="border: 1px solid #d9d9d9;padding: 4px; border-radius: 4px;" v-model="gameclasslist">
          <a-checkbox value="1">真人</a-checkbox>
          <a-checkbox value="3">体育</a-checkbox>
          <a-checkbox value="4">彩票</a-checkbox>
        </a-checkbox-group>
      </a-form-item>
    </a-form>
    <a-form layout="inline">
      <a-form-item label="上传文件">
        <a-button type="dashed" @click="dowTemplate"> 下载模板 </a-button>
      </a-form-item>
      <a-form-item>
        <a-upload :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
          <a-button> <a-icon type="upload" /> 选择文件 </a-button>
        </a-upload>
      </a-form-item>
      <a-form-item>
        <a-button type="primary" :disabled="fileList.length === 0" :loading="uploading" @click="handleUpload">
          {{ uploading ? "上传" : "开始上传" }}
        </a-button>
      </a-form-item>
      <a-form-item>
        <span style="color: red;">【同步获取】依【获取日期】时间段抓取「现金后台/返水查询」的帐号、真人/体育/彩票有效投注
        </span>
        <br />
        <span style="color: red;">
          ※若是现金后台重新返水，活动后台需要再操作获取数据，操作后直接覆盖原有数据
        </span>
      </a-form-item>
    </a-form>
    <br />
    <a-form layout="inline">
      <a-form-item>
        <a-space :size="8">
          <a-button type="primary" style="background-color: green;" @click="anewTotal(2)">本期计算
          </a-button>
          <span class="red">本期计算,将会对本期进行当期数据计算</span>
        </a-space>
      </a-form-item>
    </a-form>
    <br />
    <div style="color: red">
      <a-icon type="exclamation-circle" /> 上传文件顶部标头需要保留
      <br />
      <a-icon type="exclamation-circle" />
      注意文件上传仅支持上传.xlsx、.xls、.csv、后缀文件,建议使用CSV
      <br />
      <a-icon type="exclamation-circle" /> 会员账号不得超过50个字元
      <br />
      <a-icon type="exclamation-circle" /> 投注金额不得超过20亿 <br />
      上述两点上传检查到将自动过滤跳过
      <br />
      <a-icon type="exclamation-circle" />
      上传当期投注后,需要前往会员投注>[本期计算]计算当期后会员投注才会有数据
    </div>
  </a-layout-content>
</template>
<script>
  import XLSX from "xlsx";
  import moment from "moment";
  import { arrayExport } from "../../js/xlsxTool";
  export default {
    data() {
      return {
        fileList: [],
        uploading: false,
        termsetdata: undefined,
        defaultTermsetdata: undefined,
        dataRange,
        dateFormat: "YYYY-MM-DD",
        Sdt: "",
        Edt: "",
        gameclasslist: [],
      };
    },
    methods: {
      moment,
      isExcel(file) {
        return /\.(xlsx|xls|csv)$/.test(file.name);
      },
      handleRemove(file) {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      },
      beforeUpload(file) {
        if (!this.isExcel(file)) {
          this.$message.error("仅支持上传.xlsx、.xls、.csv、后缀文件");
          return false;
        }
        this.fileList = [file];
        return false;
      },
      handleUpload() {
        this.uploading = true;
        const that = this;
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = e => {
            const data = e.target.result;
            const workbook = XLSX.read(data, {
              type: "array",
              raw: true
            });
            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];
            const header = that.getHeaderRow(worksheet);
            // 改变头部
            worksheet["A1"].w = "UserID";
            worksheet["B1"].w = "Amount";
            const results = XLSX.utils.sheet_to_json(worksheet);
            this.generateData({
              header,
              results
            });
            resolve();
          };
          reader.readAsArrayBuffer(that.fileList[0]);
        });
      },
      // 从头计算
      anewTotal(caltype) {
        let msg = "本期计算";

        const that = this;
        this.$confirm({
          title: msg,
          content: "您确定" + msg + "？",
          onOk() {
            that.axios
              .post("/userbet/caluserbet", {
                Type: 2,
                CalType: caltype,
                TermID: that.defaultTermsetdata
              })
              .then(res => {
                if (res.data) {
                  that.$message.success(
                    "已提交服务计算,可至会员计算进度列表查询"
                  );
                }
              });
          }
        });
      },
      generateData({ header, results }) {
        //进行上传
        this.uploading = false;
        this.fileList = [];
        this.axios
          .post("/userbet/importuserrecord", {
            TermID: this.defaultTermsetdata,
            Type: 2,
            RecordList: results
          })
          .then(res => {
            if (res.data) {
              this.mymessage(this, "导入成功");
            }
          });
      },
      getHeaderRow(sheet) {
        const headers = [];
        const range = XLSX.utils.decode_range(sheet["!ref"]);
        let C;
        const R = range.s.r;
        for (C = range.s.c; C <= range.e.c; ++C) {
          const cell =
            sheet[
            XLSX.utils.encode_cell({
              c: C,
              r: R
            })
            ];
          let hdr = "UNKNOWN " + C;
          if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
          headers.push(hdr);
        }
        return headers;
      },
      // 查询周期
      qrytermset() {
        this.axios
          .post("/rank/gettermset", {
            Type: 2
          })
          .then(res => {
            if (res.data) {
              this.termsetdata = res.data;
              this.defaultTermsetdata = res.data[0].ID;
            }
          });
      },
      // 下载模板
      dowTemplate() {
        var aoa = [
          ["会员账号", "有效投注"],
          ["cehil", "9999"]
        ];
        arrayExport(aoa, "模板");
      },
      // 查询时间绑定
      onChangeDate(value, dateString) {
        this.Sdt = dateString[0];
        this.Edt = dateString[1];
      },
      //同步获取
      Getvaildbet() {
        let gameclass = '';
        if (this.gameclasslist.length == 0) {
          this.$message.error("请勾选至少一个类型");
          return;
        }

        this.gameclasslist.forEach(element => {
          gameclass += element + ","
        });
        gameclass = gameclass.endsWith(',') ? gameclass.slice(0, -1) : gameclass;

        this.axios
          .post("/userbet/getvaildbet", {
            TermID: this.defaultTermsetdata,
            Type: 2,
            Sdt: this.Sdt,
            Edt: this.Edt,
            Gameclass: gameclass,
          })
          .then(res => {
            if (res.data) {
              this.mymessage(this, "同步获取成功");
            }
          });
      }
    },
    //首次加载
    created() {
      // 初始化时间
      this.Sdt = moment()
        .startOf("week")
        .format(this.dateFormat);
      this.Edt = moment()
        .endOf("week")
        .format(this.dateFormat);
      this.qrytermset();
    }
  };

  let dataRange = {
    今天: [moment().startOf("day"), moment().endOf("day")],
    昨天: [
      moment()
        .startOf("day")
        .subtract(1, "days"),
      moment()
        .endOf("day")
        .subtract(1, "days")
    ],
    本周: [moment().startOf("week"), moment().endOf("week")],
    最近一周: [
      moment()
        .startOf("day")
        .subtract(1, "weeks"),
      moment()
    ],
    最近两周: [
      moment()
        .startOf("day")
        .subtract(2, "weeks"),
      moment()
    ],
    本月: [moment().startOf("month"), moment().endOf("month")],
    最近1个月: [
      moment()
        .startOf("day")
        .subtract(1, "months"),
      moment()
    ]
  };
</script>
<style>
  .box {
    width: 200px;
    height: 80px;
  }
</style>


// WEBPACK FOOTER //
// src/components/liveleaderboard/importdata.vue